export const getFormData = (obj, includeNullValues = false, formData?: FormData, key?) => {
  formData = formData ?? new FormData();

  if (obj === undefined || (obj === null && !includeNullValues)) {
    return formData;
  }

  if (Array.isArray(obj) && obj.length > 0) {
    obj.forEach((value, index) => {
      getFormData(value, includeNullValues, formData, `${key ?? ''}[${index}]`);
    });

    return formData;
  }

  if (obj === Object(obj) && !Array.isArray(obj) && !(obj instanceof File)) {
    Object.keys(obj).forEach((objKey) => {
      const value = obj[objKey];
      getFormData(value, includeNullValues, formData, key ? `${key}[${objKey}]` : objKey);
    });

    return formData;
  }

  formData.append(key, obj !== 0 ? obj ?? '' : '0');

  return formData;
};

export const objectMapToSelectOptions = (object: Record<string, unknown>) =>
  Object.entries(object).map(([value, label]) => ({ value, label }));
